"use strict";
exports.__esModule = true;
exports.unescapeReferenceToken = exports.escapeReferenceToken = void 0;
function escapeReferenceToken(value) {
    var result = value;
    if (result.includes('~')) {
        result = result.replaceAll('~', '~0');
    }
    if (result.includes('/')) {
        result = result.replaceAll('/', '~1');
    }
    return result;
}
exports.escapeReferenceToken = escapeReferenceToken;
function unescapeReferenceToken(value) {
    return value.replaceAll('~1', '/').replaceAll('~0', '~');
}
exports.unescapeReferenceToken = unescapeReferenceToken;
